module.exports = __webpack_public_path__ + "static/img/indexImg3.6a2f16b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/indexImg3.jpg
// module id = w6+i
// module chunks = 3